import '@hotwired/turbo-rails'
Turbo.start()
import * as ActiveStorage from '@rails/activestorage'
ActiveStorage.start()
